import Vue from "vue";
import App from "./app/App.vue";
import router from "./router";
import store from "./store";
import { createI18n } from "./i18n";
import "@/assets/css/tailwind.css";

Vue.config.productionTip = false;

async function initApp() {
  try {
    // Wait for i18n to be fully loaded
    const i18n = await createI18n(store);

    new Vue({
      i18n,
      router,
      store,
      render: h => h(App)
    }).$mount("#app");
  } catch (error) {
    console.error("Failed to initialize app:", error);
    // You could show an error message or fallback here
  }
}

// Initialize the app
initApp();
